mutation ConnectPayPal($input: ConnectPayPalInput!) {
  connectPayPal(input: $input) {
    id
    paymentSettings {
      provider
      paypal {
        clientId
        webhookUrl
        sandbox
        connectedAt
      }
    }
  }
}
